// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__3affr","spinner":"Spinner_spinner__3Xlxx","spin":"Spinner_spin__34yA-"};